import { render, staticRenderFns } from "./SearchBar.vue?vue&type=template&id=309f2af9&scoped=true"
import script from "./SearchBar.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchBar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SearchBar.vue?vue&type=style&index=0&id=309f2af9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309f2af9",
  null
  
)

export default component.exports